/**
 * Scrollbar of the kanban boards (lead board and deals board): thin, rounded and
 * tinted to the theme instead of the browser's default bar. Both engines are
 * covered — `scrollbar-*` for Firefox, `::-webkit-scrollbar` for Chromium/Safari.
 *
 * The classes are written out in full (never assembled from pieces): Tailwind
 * only generates the classes it can read literally in the source.
 */
const LIGHT =
  "[scrollbar-width:thin] [scrollbar-color:rgba(15,23,42,0.25)_transparent] [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-slate-900/20 hover:[&::-webkit-scrollbar-thumb]:bg-slate-900/40";

const DARK =
  "[scrollbar-width:thin] [scrollbar-color:rgba(255,255,255,0.25)_transparent] [&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-white/20 hover:[&::-webkit-scrollbar-thumb]:bg-white/40";

export function boardScrollbar(isDarkMode: boolean): string {
  return isDarkMode ? DARK : LIGHT;
}
